import { createBrowserRouter } from "react-router-dom";
import QRLanding from "./screens/QRLanding";
import { ConfirmationPage } from "./screens/ConfirmationPage";
import { PaymentDeclinedPage } from "./screens/PaymentDeclinedPage";
import { PaymentCancelledPage } from "./screens/PaymentCancelledPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <QRLanding />,
  },
  {
    path: "/confirmation",
    element: <ConfirmationPage />,
  },
  {
    path: "/payment/declined",
    element: <PaymentDeclinedPage />,
  },
  {
    path: "/payment/cancelled",
    element: <PaymentCancelledPage />,
  },
]);

export default router;
